if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        let checkedColors = this.form.elements.namedItem("color");
        if (!Object.keys(checkedColors).length > 0) {
          checkedColors = !!checkedColors ? [checkedColors] : [];
        }
        if (!checkedColors.length) {
          this.handleErrorMessage("Please select at least one color.");
          return;
        }
        const customChecked = Array.from(checkedColors).filter(
          (element) => element.dataset.colorCode === "custom"
        );
        if (customChecked.length > 0) {
          if (
            customChecked[0].dataset.colorName === "Custom" ||
            customChecked[0].dataset.colorName.length < 4
          ) {
            this.handleErrorMessage(
              "Custom color's name must be at least 4 charaters."
            );
            return;
          }
        }
        const variantId = this.variantIdInput.value;

        // Disable submit button and show loading
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const items = [];
        checkedColors.forEach((checkbox) => {
          const colorName = checkbox.dataset.colorName;
          const extra = checkbox.dataset.extra;

          const relatedVariantId = checkbox.closest("li").id.split("-")[0];
          const quantityInput = checkbox
            .closest("li")
            .querySelector(".quantity__input");
          const colorImg = checkbox.nextElementSibling;
          const quantity = parseInt(quantityInput.value, 10);

          const request = {
            id: relatedVariantId.includes("color")
              ? variantId
              : relatedVariantId,
            properties: {
              "Color name": `${colorName}`,
              _color_image: colorImg ? colorImg.src : "",
            },
            quantity: quantity,
          };

          if (extra > 0) {
            request.properties.Extra = `${extra}%`;
          }

          items.push(request);
        });
        const cartRequest = { items: items };
        if (this.cart) {
          cartRequest.sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id);

          cartRequest.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        const config = fetchConfig("javascript");
        config.body = JSON.stringify(cartRequest);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers"
            );
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker
                );
              });
            this.handleErrorMessage(false);
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
